<dx-chart class="mb-3"
          [pathModified]="true"
          [dataSource]="itemStatuses"
          [customizePoint]="customizePoint">
    <dxo-chart-size [height]="200"></dxo-chart-size>
    <dxo-chart-common-series-settings type="stackedbar"> </dxo-chart-common-series-settings>

    <dxo-chart-tooltip [enabled]="true"
                       [customizeTooltip]="customizeTooltip"
                       [paddingLeftRight]="8"
                       [paddingTopBottom]="8"
                       color="black">
        <dxo-chart-font [weight]="500"
                        color="white"></dxo-chart-font>
        <dxo-chart-border [visible]="false"></dxo-chart-border>
    </dxo-chart-tooltip>

    <dxi-chart-series valueField="onScheduleCount"
                      argumentField="name"
                      [name]="onScheduleSeriesName"> </dxi-chart-series>

    <dxi-chart-series valueField="overdueCount"
                      argumentField="name"
                      [name]="overdueSeriesName"> </dxi-chart-series>

    <dxi-chart-value-axis [visible]="false">
        <dxo-chart-label [visible]="false"></dxo-chart-label>
        <dxo-chart-grid [visible]="false"></dxo-chart-grid>
    </dxi-chart-value-axis>

    <dxo-chart-argument-axis [visible]="false">
        <dxo-chart-label overlappingBehavior="stagger"
                         wordWrap="none"> </dxo-chart-label>
    </dxo-chart-argument-axis>

    <dxo-chart-legend [visible]="false"></dxo-chart-legend>
</dx-chart>
